$(document).ready(function () {
  // .botm_menuを非表示/表示　ページが下までスクロールされたら非表示
  $(window).on("scroll", function () {
    var scrollHeight = $(document).height();
    var scrollPosition = $(window).height() + $(window).scrollTop();
    //var offset = 500;  非表示にしたい位置（100ピクセル手前）

    if (scrollHeight - scrollPosition <= 500) {
      $(".botm_menu").fadeOut("slow"); // 下までスクロールしたら非表示
    } else {
      $(".botm_menu").fadeIn("slow"); // それ以外では表示
    }
  });
});
